/** 图片字节大小估算（供图片空间容量统计与入库切面共用） */

export function estimateDataUrlByteSize(dataUrl) {
  if (typeof dataUrl !== 'string' || !dataUrl.startsWith('data:')) return null;
  const base64 = dataUrl.split(',')[1];
  if (!base64) return null;
  const padding = (base64.match(/=+$/) || [''])[0].length;
  const bytes = Math.floor((base64.length * 3) / 4) - padding;
  return Number.isFinite(bytes) && bytes > 0 ? bytes : null;
}

export function normalizePositiveByteSize(raw) {
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function resolveRecordByteSize(record = {}, fileMeta = {}) {
  const direct = [
    record.size,
    record.fileSize,
    record.byteSize,
    fileMeta.size,
    fileMeta.fileSize,
    fileMeta.byteSize,
  ];
  for (const raw of direct) {
    const n = normalizePositiveByteSize(raw);
    if (n != null) return n;
  }

  const candidates = [
    record.dataUrl,
    record.originalDataUrl,
    record.compressedDataUrl,
    record.url,
    record.src,
    record.imageUrl,
    fileMeta.dataUrl,
  ].filter((item) => typeof item === 'string' && item.trim());

  for (const candidate of candidates) {
    const estimated = estimateDataUrlByteSize(candidate);
    if (estimated) return estimated;
  }

  return null;
}
